import(/* webpackMode: "eager" */ "/home/runner/work/irs-extension.com/irs-extension.com/components/forgotPage.js");
import(/* webpackMode: "eager" */ "/home/runner/work/irs-extension.com/irs-extension.com/components/layout.js")